import React from 'react'
import { checkTextTranslation, imageAddress } from '../../utils/useful'
// import PDFViewer from './PDFViewer';
class TableImageInput extends React.Component {
  state = {
  }


  changeInputValue(target) {
    let value = (target.validity.valid) ? target.value : null
    if (value !== null) {
      this.props.changeValue(this.props.header.key, value)
    }
  }


  render() {

    return (

      <div className={`${this.props.onTable ? '' : 'text-center d-flex justify-content-center w-100'} `} style={{ overflow: 'auto' }}>
        {Array.isArray(this.props.data) && this.props.data.map((image, index) => {
          return (
            <>
            {/* {image.includes('.pdf') ?(
    <div>
    <PDFViewer />
</div>
            ):(

               */}
              <a href={imageAddress(image)} target="_blank"><img key={index} src={'/images/file.svg'} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: 2 }} /></a>
            {/* )
            } */}
            </>
          )
        })
        }

        {!Array.isArray(this.props.data) && this.props.data && (
          <a href={imageAddress(this.props.data)} target="_blank"><img src={'/images/file.svg'} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover' }} /></a>
        )}

      </div>

      // <div className="w-100 h-100">
      //     <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data}</p>
      // </div>
    )
  }
}

export default TableImageInput;